// STYLIST PAGE ACTIONS
export const CONTACT_STYLIST_REQUEST = 'CONTACT_STYLIST_REQUEST';
export const CONTACT_STYLIST_SUCCESS = 'CONTACT_STYLIST_SUCCESS';
export const CONTACT_STYLIST_FAILURE = 'CONTACT_STYLIST_FAILURE';

export const CONTACT_FORM_RESET = 'CONTACT_FORM_RESET';

// Booking
export const APPOINTMENT_NEW = 'APPOINTMENT_NEW';
export const APPOINTMENT_RESET = 'APPOINTMENT_RESET';
export const APPOINTMENT_NEXT_STEP = 'APPOINTMENT_NEXT_STEP';
export const APPOINTMENT_NEXT_DATE_SLOT = 'APPOINTMENT_NEXT_DATE_SLOT';
export const APPOINTMENT_PREV_DATE_SLOT = 'APPOINTMENT_PREV_DATE_SLOT';
export const APPOINTMENT_UPDATE = 'APPOINTMENT_UPDATE';
export const APPOINTMENT_AUTO_BOOK_ERROR = 'APPOINTMENT_AUTO_BOOK_ERROR';

export const APPOINTMENT_UPDATE_DATE_AND_TIMES =
  'APPOINTMENT_UPDATE_DATE_AND_TIMES';

export const GET_AVAILABLE_DATES_REQUEST = 'GET_AVAILABLE_DATES_REQUEST';
export const GET_AVAILABLE_DATES_SUCCESS = 'GET_AVAILABLE_DATES_SUCCESS';
export const GET_AVAILABLE_DATES_FAILURE = 'GET_AVAILABLE_DATES_FAILURE';

export const GET_PAYMENT_SETTING_FOR_CLIENT_REQUEST =
  'GET_PAYMENT_SETTING_FOR_CLIENT_REQUEST';
export const GET_PAYMENT_SETTING_FOR_CLIENT_SUCCESS =
  'GET_PAYMENT_SETTING_FOR_CLIENT_SUCCESS';
export const GET_PAYMENT_SETTING_FOR_CLIENT_FAILURE =
  'GET_PAYMENT_SETTING_FOR_CLIENT_FAILURE';

export const GET_CARD_TOKEN_REQUEST = 'GET_CARD_TOKEN_REQUEST';
export const GET_CARD_TOKEN_SUCCESS = 'GET_CARD_TOKEN_SUCCESS';
export const GET_CARD_TOKEN_FAILURE = 'GET_CARD_TOKEN_FAILURE';

export const SUBMIT_BOOKING_REQUEST = 'SUBMIT_BOOKING_REQUEST';
export const SUBMIT_BOOKING_SUCCESS = 'SUBMIT_BOOKING_SUCCESS';
export const SUBMIT_BOOKING_FAILURE = 'SUBMIT_BOOKING_FAILURE';
export const SUBMIT_BOOKING_CLEAR_ERROR = 'SUBMIT_BOOKING_CLEAR_ERROR';
export const SUBMIT_BOOKING_RESCHEDULE_REQUEST =
  'SUBMIT_BOOKING_RESCHEDULE_REQUEST';
export const SUBMIT_BOOKING_RESCHEDULE_SUCCESS =
  'SUBMIT_BOOKING_RESCHEDULE_SUCCESS';
export const SUBMIT_BOOKING_RESCHEDULE_FAILURE =
  'SUBMIT_BOOKING_RESCHEDULE_FAILURE';

export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const UNSELECT_SERVICE = 'UNSELECT_SERVICE';
export const MAX_APPOINTMENTS_WARNING_ACKNOWLEDGED =
  'MAX_APPOINTMENTS_WARNING_ACKNOWLEDGED';
export const SELECT_SERVICE_REJECTED = 'SELECT_SERVICE_REJECTED';
export const SELECT_SERVICE_CATEGORY = 'SELECT_SERVICE_CATEGORY';
export const CLEAR_SERVICE_CATEGORY = 'CLEAR_SERVICE_CATEGORY';

export const CLEAR_PROFESSIONAL = 'CLEAR_PROFESSIONAL';
export const SELECT_PROFESSIONAL = 'SELECT_PROFESSIONAL';

// Navigation
export const LOCATION_CHANGE = 'LOCATION_CHANGE';

export const PURCHASE_GIFT_CARD_REQUEST = 'PURCHASE_GIFT_CARD_REQUEST';
export const PURCHASE_GIFT_CARD_SUCCESS = 'PURCHASE_GIFT_CARD_SUCCESS';
export const PURCHASE_GIFT_CARD_FAILURE = 'PURCHASE_GIFT_CARD_FAILURE';
export const GIFT_CARD_FORM_LOADING_START = 'GIFT_CARD_FORM_LOADING_START';
export const GIFT_CARD_FORM_LOADING_STOP = 'GIFT_CARD_FORM_LOADING_STOP';
export const RESET_GIFT_CARD_STATE = 'RESET_GIFT_CARD_STATE';
